import { Chip, TableCell } from '@mui/material'

const TableCellSesso = ({ sesso }) => {
  const color =
    (sesso === 'F' && 'secondary') || (sesso === 'M' && 'info') || 'default'

  return (
    <TableCell>
      <Chip color={color} label={sesso} />
    </TableCell>
  )
}

export default TableCellSesso
